import axiosInstance from "./service-instance";
import { CONTENT_TYPES } from "constants";
import { createUrl } from "utilities";
const CASE_LIST_URL = createUrl(["case", "v2", "list", "test"]);

const fetchBucketCases = (stage_ids, type, page, page_size, filters, document) => {
    return axiosInstance.get(CASE_LIST_URL, {
        params: {
            stage_ids,
            type,
            page,
            page_size,
            document,
            ...filters
        },
        headers: {
            "Content-Type": CONTENT_TYPES.APPLICATION_JSON
        }
    });
};

const assignCaseFromBucket = (case_id) => {
    return axiosInstance.post("/case/assign/", {
        case_id
    }, {
        headers: {
            "Content-Type": CONTENT_TYPES.APPLICATION_JSON
        }
    });
};

const proceedCaseFromBucket = (case_task_id, this_stage, remarks) => {
    return axiosInstance.put("/case/proceed-bucket/", {
        this_stage,
        remarks
    }, {
        params: {
            case_task_id
        },
        headers: {
            "Content-Type": CONTENT_TYPES.APPLICATION_JSON
        }
    });
};

const referCaseFromBucket = (case_task_id, this_stage, remarks) => {
    return axiosInstance.put("/case/refer-bucket/", {
        this_stage,
        remarks
    }, {
        params: {
            case_task_id
        },
        headers: {
            "Content-Type": CONTENT_TYPES.APPLICATION_JSON
        }
    });
};

const bulkCaseAssign = (case_task_ids, this_user, remarks) =>
    axiosInstance.post("/case/bulk-assign/", {
        case_task_ids,
        this_user,
        remarks
    }, {
        headers: {
            "Content-Type": "application/json"
        }
    });

const bulkMoveCases = (body) =>
    axiosInstance.post("/case/bulk-move/", body, {
            headers: {
                "Content-Type": "application/json"
            }
        });

export default {
    fetchBucketCases,
    proceedCaseFromBucket,
    assignCaseFromBucket,
    referCaseFromBucket,
    bulkCaseAssign,
    bulkMoveCases
};